import LegislativnyProcesDetail from './LegislativnyMaterialDetailPage';

export default LegislativnyProcesDetail;
